import instance from "../config/interceptor";
import axios from "axios";
import { BASE_API_URL } from "../config/api";

export const uploadImage = async (file, post_type, setHeaderStyle) => {
  const file_extension = "." + file.type.split("/")[1];
  // eslint-disable-next-line
  const api_path = BASE_API_URL + "/dashboard/files";

  const response = await instance.post(
    api_path,
    {},
    {
      params: { extension: file_extension, type: post_type },
    }
  );

  // New Supabase-backed contract: { uploadUrl, publicUrl, ... }
  // Legacy S3 contract: response.data was a presigned URL string.
  const payload = response?.data;
  const uploadUrl =
    typeof payload === "string" ? payload : payload?.uploadUrl;
  const publicUrl =
    typeof payload === "string"
      ? payload.split("?X")[0]
      : payload?.publicUrl;

  if (!uploadUrl || !publicUrl) {
    throw new Error("Invalid upload response from server");
  }

  const unintercepted = axios.create();
  const upload = await unintercepted.put(uploadUrl, file, {
    headers: {
      "Content-type": file.type,
      "Access-Control-Allow-Origin": "*",
    },
  });
  if (upload.status !== 200) {
    throw new Error(response.message || "Something went wrong!");
  }

  if (setHeaderStyle) setHeaderStyle(publicUrl);

  return publicUrl;
};

export const getDiagnosisOption = async ({ page = 0, keyword, size = 10 }) => {
  let _response;
  try {
    let link = `${BASE_API_URL}/dashboard/icd10?`;
    link = link.concat("page=" + page);
    link = link.concat("&size=" + size);
    if (keyword) link = link.concat("&keyword=" + keyword);

    const response = await instance.get(link);
    _response = response;
  } catch ({ response }) {
    _response = response;
  }
  return _response;
};

export const getServicesType = async () => {
  let _response;
  try {
    let link = `${BASE_API_URL}/onboarding/services`;

    const response = await instance.get(link);
    _response = response;
  } catch ({ response }) {
    _response = response;
  }
  return _response;
};

export const getBusinessType = async () => {
  let _response;
  try {
    let link = `${BASE_API_URL}/onboarding/business-types`;

    const response = await instance.get(link);
    _response = response;
  } catch ({ response }) {
    _response = response;
  }
  return _response;
};

export const getDoctorByBusinessId = async (id) => {
  try {
    const host = typeof window !== "undefined" ? window.location.hostname : "";
    let nextOrigin;
    if (host.includes("stg.")) {
      nextOrigin = "https://stg.new.sistemklinik.com";
    } else if (host.startsWith("preprod.")) {
      nextOrigin = "https://preprod.new.sistemklinik.com";
    } else if (host && !host.includes("localhost")) {
      nextOrigin = "https://www.new.sistemklinik.com";
    } else {
      nextOrigin = process.env.REACT_APP_NEXT_API_URL || "https://www.new.sistemklinik.com";
    }

    const cleanOrigin = nextOrigin.replace(/\/api\/legacy\/?$/, "").replace(/\/$/, "");
    const link = `${cleanOrigin}/api/legacy/service-provider/provider/${id}`;

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};
